import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import { buildSelectionSwitchBlock } from './demoSelectionSwitch.js'
import {
  WEBSITE_CRM_BEFORE_BUILD_MARKDOWN,
  WEBSITE_CRM_INTRO_MARKDOWN,
} from './websiteCrmDemoContent.part01.js'
import {
  WEBSITE_CRM_AI_LOG_STEPS_INITIAL,
} from './websiteCrmDemoContent.part04.js'
import {
  WEBSITE_CRM_AI_LOG_STEPS_BUILD_SITE,
} from './websiteCrmDemoContent.part05.js'

export const WEBSITE_CRM_AI_LOG_STEPS = [
  ...WEBSITE_CRM_AI_LOG_STEPS_INITIAL,
  ...WEBSITE_CRM_AI_LOG_STEPS_BUILD_SITE,
]

/**
 * @param {string} htmlArtifactId
 * @returns {object[]}
 */

export function buildWebsiteCrmPhase1FinalBlocks(htmlArtifactId) {
  return [
    { type: 'markdown', content: WEBSITE_CRM_INTRO_MARKDOWN },
    {
      type: 'aiResponseLog',
      status: 'ok',
      showLogStatus: false,
      steps: buildWorkflowTimeline(WEBSITE_CRM_AI_LOG_STEPS_INITIAL),
    },
    { type: 'markdown', content: WEBSITE_CRM_BEFORE_BUILD_MARKDOWN },
    {
      type: 'aiResponseLog',
      status: 'ok',
      showLogStatus: false,
      steps: buildWorkflowTimeline(WEBSITE_CRM_AI_LOG_STEPS_BUILD_SITE),
    },
    {
      type: 'fileArtifact',
      fileName: 'NexusB2B — Procurement Site.html',
      description: 'HTML App',
      artifactKind: 'html',
      artifactId: htmlArtifactId,
    },
    buildSelectionSwitchBlock('persona', 'Architect', 'Sales'),
  ]
}

/** Blocks streamed before the closing summary tail in the combined website + CRM demo. */

export const WEBSITE_CRM_FULL_STREAM_PREFIX_BLOCK_COUNT = 17

/**
 * @param {string} htmlArtifactId
 * @param {string} zohoArtifactId
 * @param {string} docArtifactId
 * @returns {object[]}
 */
/** Blocks streamed before the closing summary tail in the CRM-connect-only demo stream. */

export const WEBSITE_CRM_CONNECT_STREAM_PREFIX_BLOCK_COUNT = 9
